/**
 * Selector that matches elements without any visual content.
 * Note: iframe can be considered as a non-visual element, because we cannot access it content outside of the iframe
 */
export const nonVisualElementSelector =
  'script, style, template, link, noscript, meta, iframe, base, area, br, col, colgroup, param, source, track, wbr, hr, path, circle, rect, ellipse, line, polygon, polyline, g';
export const nonVisualAttributesSelector = '[hidden], input[type="hidden"]';
const nonVisualSelector =
  nonVisualElementSelector + ',' + nonVisualAttributesSelector;

/**
 * Returns the descendants which has no visual content
 */
export function getNonVisualDescendants(element: Element): Element[] {
  return Array.from(element.querySelectorAll(nonVisualSelector));
}

/**
 * Determines whether the given element has no visual content
 */
export function isNonVisualElement(element: Element) {
  return element?.matches(nonVisualSelector);
}
